import { Grid2 } from "@mui/material";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";

export function TicketAffidavit({ data, setData, handleChange }: {
    data: any;
    setData: (_data: any) => void;
    handleChange: (event: any) => void;
}) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="courtRecordNumber"
                    name="courtRecordNumber"
                    label="Court Record Number"
                    fullWidth
                    value={data.courtRecordNumber}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="courtType"
                    name="courtType"
                    label="Court Type"
                    fullWidth
                    value={data.courtType}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="courtArea"
                    name="courtArea"
                    label="Court Area"
                    fullWidth
                    value={data.courtArea}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="titleOfProceedings"
                    name="titleOfProceedings"
                    label="Title Of Proceedings (X vs Y)"
                    fullWidth
                    value={data.titleOfProceedings}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="servedBy"
                    name="servedBy"
                    label="Served By"
                    fullWidth
                    value={data.servedBy}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="affidavitDate"
                    name="affidavitDate"
                    label="Date and Time"
                    type="datetime-local"
                    fullWidth
                    value={data.affidavitDate}
                    onChange={handleChange}
                />
            </Grid2>
        </>
    );
}
